import * as serviceContext from './serviceContext';
var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function addControl(data, masterPassword) {
    options.headers = new Headers({
        'MasterPassword': masterPassword
    });
    try {
        const response = await serviceContext.post("gamecontrol/casinocontrol", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCreatedByMe() {
    try {
        const response = await serviceContext.get("gamecontrol/casinocontrol/createdby", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getMyControl() {
    try {
        const response = await serviceContext.get("gamecontrol/casinocontrol/my", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getControlByUser(usr) {
    try {
        const response = await serviceContext.get("gamecontrol/casinocontrol/users/"+usr, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCreatedByParent() {
    try {
        const response = await serviceContext.get("gamecontrol/casinocontrol/parents", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getIPGames() {
    try {
        const response = await serviceContext.get("casino/games/LOTUS", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getIP2Games() {
    try {
        const response = await serviceContext.get("casino/games/SUPERNOVA", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


